const SAITAMA_INSPECTION_TABLES = Object.freeze({
  dev: Object.freeze({
    resultTable: "PicTreeViewerInspectionResultSaitamaDev",
    itemTable: "PicTreeViewerInspectionResultItemSaitamaDev",
  }),
  prod: Object.freeze({
    resultTable: "PicTreeViewerInspectionResultSaitamaProd",
    itemTable: "PicTreeViewerInspectionResultItemSaitamaProd",
  }),
});

export const resolveSaitamaInspectionTables = (environment = process.env.REACT_APP_ENV) => {
  const tables = SAITAMA_INSPECTION_TABLES[environment];
  if (!tables) {
    throw new Error(`Unsupported Saitama inspection environment: ${environment || "missing"}`);
  }
  return tables;
};

